import StyledDecedentInitiation from '@/pages/decedent-initiation/DecedentInitiation';
import { useQueryClient } from '@tanstack/react-query';
import { StepperProvider } from '@/common/components/Stepper/index';
import { STEPS, STEPS_FORM } from '@/pages/decedent-initiation/constants';
import {
  useCurrentDecedent,
  useCurrentDecedentSections,
} from '@/app/providers/DecedentProvider';
import {
  useEditDecedentMutation,
  useSubmitQuestionMutation,
} from '@/entities/decedent';
import { userQueryKeys } from '@/entities/user/user.keys';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

const DecedentInitiation = (props) => {
  const { t, i18n } = useTranslation();
  const sections = useCurrentDecedentSections();
  const decedent = useCurrentDecedent();
  const queryClient = useQueryClient();
  const editDecedentMutation = useEditDecedentMutation({
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: userQueryKeys.current,
      });
    },
  });
  const submitQuestionMutation = useSubmitQuestionMutation();
  const initialStep = useMemo(() => {
    if (!sections) return 0;
    let res = 0;
    for (let i = 0; i < STEPS_FORM.length; i++) {
      const form = STEPS_FORM[i];
      if (!sections?.[form]?.question?.passed) {
        res = i;
        break;
      }
    }

    return res;
  }, [sections]);

  const localizedSteps = useMemo(
    () => STEPS.map((step) => t(step)),
    [t, i18n.language]
  );

  return (
    <StepperProvider steps={localizedSteps} initialStep={initialStep}>
      <StyledDecedentInitiation
        {...props}
        decedent={decedent}
        editDecedent={editDecedentMutation.mutateAsync}
        submitQuestion={submitQuestionMutation.mutateAsync}
        showIntro={initialStep === 0}
      />
    </StepperProvider>
  );
};

export default DecedentInitiation;
